import React, { useState } from "react";
import { TextHeader } from "components/Texts";

import Row from "components/Row";
import SigninButton from "components/facebook/SigninButton";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Modal from "components/Modal";
import Button from "components/Buttons";
import { Cross } from "@styled-icons/entypo/Cross";

const LoginModal = ({ show, setShow, reload }) => {
  const [modalLoginFacebookDisplay, setModalLoginFacebookDisplay] = useState("hide");

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();

  const handleLoginFacebookCloseModal = () => {
    setShow("hide");
  };

  const modalLoginFacebookContent = (
    <ModalContentContainer>
      <StyledContainer>
        <StyledCrossIcon onClick={handleLoginFacebookCloseModal} />

        <SetupMainContainer>
          <SetupMainSubContainer>
            <SetupFacebookTitle>{t("__fbads_setup_sub_title")}</SetupFacebookTitle>
            <SigninButton reload={reload} />
          </SetupMainSubContainer>
        </SetupMainContainer>
      </StyledContainer>
    </ModalContentContainer>
  );

  const view = () => {
    return (
      <>
        <Modal state={show} content={modalLoginFacebookContent} />
      </>
    );
  };

  return view();
};

export default LoginModal;

const SetupMainSubContainer = styled.div`
  text-align: center;
  line-height: 2.5em;
`;

const SetupMainContainer = styled.div`
  display: flex;
  background-color: #fbfeff;
  border-radius: 10px;
  border: 1px solid #f5f9fc;
  padding: 20px 5px;
  justify-content: center;
  align-item: center;
`;

const SetupFacebookTitle = styled.div`
  font-size: 1rem;
  margin-bottom: 10px;
`;

const StyledContainer = styled.div`
  font-size: 14px;
  color: #555;
  position: relative;

  .m-b-10 {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 834px) {
    .links-container {
      display: flex;
      justify-content: center;
    }
  }
`;

const ModalContentContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
  color: #575757;
  font-weight: bold;

  .info-icon {
    font-size: 78px;
    color: #f8bb86;
    margin-bottom: 20px;
    font-weight: normal;
  }
`;

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 16px;

  > Button {
    min-width: 100px;
    margin-bottom: 0px;
  }

  > Button:first-child {
    margin-right: 10px;
  }
`;

const StyledCrossIcon = styled(Cross)`
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 10px;
  width: 40px;
  cursor: pointer;
`;
